module.exports = __webpack_public_path__ + "static/img/solution-3.ff7107d1.png";